<template>
  <aside class="article-sidebar" aria-label="Article resources">
    <nav v-if="links.length" aria-label="Table of contents">
      <h2 class="editorial-label">Table of contents</h2>
      <ol>
        <li v-for="(link, index) in links" :key="link.id">
          <a
            :href="`#${link.id}`"
            :data-testid="`toc-link-${link.id}`"
            :aria-current="activeId === link.id ? 'location' : undefined"
            :class="{ active: activeId === link.id }"
          >
            <span>{{ String(index + 1).padStart(2, '0') }}</span>
            {{ link.text }}
          </a>
        </li>
      </ol>
    </nav>
    <div class="sidebar-extras"><slot /></div>
  </aside>
</template>
<script setup lang="ts">
const props = defineProps<{ links: Array<{ id: string; text: string }> }>()
const activeId = ref('')
let observer: IntersectionObserver | undefined
onMounted(() => {
  observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) if (entry.isIntersecting) activeId.value = entry.target.id
    },
    { rootMargin: '0px 0px -70% 0px' }
  )
  props.links.forEach((link) => {
    const heading = document.getElementById(link.id)
    if (heading) observer?.observe(heading)
  })
})
onBeforeUnmount(() => observer?.disconnect())
</script>
